document.addEventListener("DOMContentLoaded", function(){
  App.readyCallbacks.forEach((c) => c.call())
  delete App.readyCallbacks
});
